<div class="alert alert-info mb-3" role="note">
  An employee must match every filter in this rule. Each member type can be selected once.
</div>

<div class="text-secondary py-3" *ngIf="loading">Loading member options…</div>
<div class="alert alert-danger" role="alert" *ngIf="loadError">{{ loadError }}</div>

<div class="member-filter-list" *ngIf="!loading">
  <div class="member-filter-row" *ngFor="let filter of filters; let index = index">
    <div class="member-filter-operator" *ngIf="index > 0" aria-hidden="true">AND</div>
    <div class="row g-2 align-items-start">
      <div class="col-md-4">
        <label class="form-label" [for]="'member-filter-type-' + index">Member type</label>
        <select
          class="form-select"
          [class.is-invalid]="touched && validationMessage"
          [id]="'member-filter-type-' + index"
          [ngModel]="filter.group"
          (ngModelChange)="changeType(index, $event)"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="disabled"
          (blur)="markTouched()"
        >
          <option
            *ngFor="let type of memberTypes"
            [value]="type.value"
            [disabled]="isTypeUnavailable(type.value, index)"
          >{{ type.label }}</option>
        </select>
      </div>
      <div class="col">
        <label class="form-label">Member record</label>
        <app-autocomplete-select
          [ngModel]="filter.id || ''"
          (ngModelChange)="changeRecord(index, $event)"
          [ngModelOptions]="{ standalone: true }"
          [options]="options(filter.group)"
          [optionScope]="filter.group"
          [disabled]="disabled || filter.group === 'all'"
          [selectClass]="touched && filter.group !== 'all' && !filter.id ? 'form-select is-invalid' : 'form-select'"
          [placeholder]="filter.group === 'all' ? 'All employees' : 'Select a record'"
        ></app-autocomplete-select>
      </div>
      <div class="col-auto member-filter-remove">
        <button
          class="btn btn-icon btn-ghost-danger"
          type="button"
          title="Remove filter"
          aria-label="Remove member filter"
          [disabled]="disabled"
          (click)="removeFilter(index)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18 6l-12 12"/><path d="M6 6l12 12"/></svg>
        </button>
      </div>
    </div>
  </div>

  <div class="text-center text-secondary py-4" *ngIf="!filters.length">
    No filters have been added to this member rule.
  </div>

  <div class="invalid-feedback d-block mb-2" *ngIf="touched && validationMessage">
    {{ validationMessage }}
  </div>

  <button class="btn btn-primary" type="button" [disabled]="!canAddFilter" (click)="addFilter()">
    Add filter
  </button>
</div>
